<template>
  <div class="rightContainer">
    <div class="correlationHot">
      <div>热门文章</div>
      <div @click="articleSwitch1" class="point">
        换一换<img style="margin-left: 10px;" src="~@/assets/img/frontierPage/change.png" />
      </div>
    </div>
    <div class="cut-off"></div>
    <div v-for="item in articleHot" @click="detailJump(item)" class="titlePopular">
      <img src="~@/assets/img/frontierPage/article-title-ellipse.png" />{{ item.title }}
    </div>
    <div class="correlationHot">
      <div>热门标签</div>
      <div class="point" @click="switchingLabel">
        换一换<img style="margin-left: 10px;" src="~@/assets/img/frontierPage/change.png" />
      </div>
    </div>
    <div class="cut-off"></div>
    <div class="">
      <div @click="jumpTag(item)" v-for="item in currentTags" :key="item.id" class="tag">{{ item.name }}</div>
    </div>
    <div class="correlationHot">
      <div>相关文章</div>
      <div class="point" @click="articleSwitch2">
        换一换<img style="margin-left: 10px;" src="~@/assets/img/frontierPage/change.png" />
      </div>
    </div>
    <div class="cut-off"></div>
    <div v-for="item in articleRelevance" @click="detailJump(item)" class="titleRelated">
      <img src="~@/assets/img/frontierPage/article-title-ellipse.png" />
      {{ item.title }}
    </div>
  </div>
</template>

<script>
  import {getContentInfo} from "../api/frontierPage";

  export default {
    name: "FrontierRightPage",
    data() {
      return{
        articleHot: [],
        articleRelevance: [],
        maximumLabel: 0,
        pageMaximum1: 0,
        pageMaximum2: 0,
        tagArticleData: {
          channelId:291,
          pageSize: 10,
        },
        numberPage1: 1,
        numberPage2: 1,
        pageLabel: 1,
        fixedTagList: [
          {id: 379, name: "轻骑兵"},
          {id: 5361, name: "轻骑兵低代码"},
          {id: 2869, name: "低代码平台"},
          {id: 4172, name: "低代码平台应用"},
          {id: 2873, name: "企业级低代码"},
          {id: 4671, name: "低代码PaaS平台"},
          {id: 4087, name: "轻骑兵低代码PaaS平台"},
          {id: 5362, name: "企业级低代码 PaaS 平台"},
          {id: 5363, name: "信创低代码平台"},
          {id: 2865, name: "低代码选型"},
          {id: 3585, name: "低代码平台推荐"},
          {id: 4171, name: "低代码平台价值"},
          {id: 5365, name: "国企低代码平台"},
          {id: 5366, name: "能源行业低代码"},
          {id: 5367, name: "金融行业低代码"},
          {id: 4909, name: "制造业低代码"},
          {id: 5051, name: "交通行业低代码"},
          {id: 2868, name: "低代码平台功能"},
          {id: 2816, name: "券商低代码"},
          {id: 4955, name: "AI低代码"},
          {id: 5628, name: "企业级报表工具"},
          {id: 5629, name: "报表工具选型"},
          {id: 5630, name: "信创报表工具"}
        ],
        currentTagPage: 0, 
        tagsPerPage: 9
      }
    },
    computed: {
      currentTags() {
        if (this.currentTagPage === 0) {
          return this.fixedTagList.slice(0, 9);
        } else {
          return this.fixedTagList.slice(9);
        }
      }
    },
    methods: {
      detailJump(item) {
        item.channelId = this.tagArticleData.channelId;
        this.$emit('openDetail',item)
      },
      articleSwitch1() {
        let self = this
        self.numberPage1++;
        if (self.numberPage1 > self.pageMaximum1) self.numberPage1 = 1;
        self.tagArticleData.pageNo = self.numberPage1
        self.tagArticleData.sort = 'contentCount'
        getContentInfo(self.tagArticleData).then((res) => {
          if (res.status === 200)
            self.articleHot = res.data.content;
        });
      },
      articleSwitch2() {
        const self = this;
        self.numberPage2++;
        if (self.numberPage2 > self.pageMaximum2) self.numberPage2 = 1;
        self.tagArticleData.pageNo = self.numberPage2
        self.tagArticleData.sort = 'topLevel'
        getContentInfo(self.tagArticleData).then((res) => {
          if (res.status === 200)
            self.articleRelevance = res.data.content;
        });
      },
      jumpTag(item) {
        this.$emit('jumpTag',item)
      },
      switchingLabel() {
        // 切换标签
        this.currentTagPage = 1 - this.currentTagPage;
      },
      getContentInfo_channelId() {
        let self = this
        self.tagArticleData.pageNo = 1
        self.tagArticleData.sort = 'contentCount'
        getContentInfo(self.tagArticleData).then((res) => {
          if (res.status === 200) {
            self.articleHot = res.data.content;
            self.pageMaximum1 =  Math.ceil(res.data.total / 10);
          }
        });
        self.tagArticleData.sort = 'topLevel'
        getContentInfo(self.tagArticleData).then((res) => {
          if (res.status === 200) {
            self.articleRelevance = res.data.content;
            self.pageMaximum2 =  Math.ceil(res.data.total / 10);
          }
        });
      }
    },
    mounted() {
      const self = this;
      self.getContentInfo_channelId()
    }
  }
</script>

<style scoped>
  .point {cursor: pointer}
  .rightContainer .correlationHot {justify-content: space-between;display: flex;}
  .rightContainer .correlationHot:nth-of-type(n + 2) {margin-top: 30px;}
  .rightContainer .correlationHot > div:nth-of-type(1) {font-size: 18px;font-weight: bold;color: #3e3a39;}
  .rightContainer .correlationHot > div:nth-of-type(2) {font-size: 14px;font-weight: 400;color: #999999;}
  .rightContainer .cut-off {margin-top: 14px;margin-bottom: 27px;background: #e7ecf0;height: 1px;}
  .rightContainer .titlePopular, .rightContainer .titleRelated {margin-top: 22px;font-size: 14px;font-weight: 400;color: #3e3a39;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;cursor: pointer;}
  .rightContainer .titlePopular img,.rightContainer .titleRelated img{margin-right: 16px;}
  .tag {margin-right: 10px;margin-bottom: 10px;display: inline-block;width: max-content;padding: 10px;color: #408cf6;cursor: pointer;background: url('~@/assets/img/frontierPage/tag.png');background-size: 100% 100%;font-size: 14px;}
</style>



// WEBPACK FOOTER //
// src/components/FrontierRightPage.vue